import { encodeQueryData } from 'Utils/Common';
import http from './httpService';
const API_URL_TARGET = process.env.REACT_APP_API_URL_TARGET;
const API_URL_SHAREHOLDER = process.env.REACT_APP_API_URL_SHAREHOLDER;


async function getallhousingcompany(params:any) {
    const url = `${API_URL_TARGET}getAllCustomers?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function getshareholder(params:any) {
    const url = `${API_URL_SHAREHOLDER}Shareholderdata?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function getallshareholder(params:any) {
    const url = `${API_URL_SHAREHOLDER}Listofallshareholders?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function getmorethanoneapartment(params:any) {
    const url = `${API_URL_SHAREHOLDER}peoplewithmorethanoneapartment?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function getcompanyshareholder(params:any) {
    const url = `${API_URL_SHAREHOLDER}companyheldapartments?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function getmorethantenpercent(params:any) {
    const url = `${API_URL_SHAREHOLDER}peoplewithmorethan10pershares?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function saveTender(params:any) {
    const url = `${API_URL_TARGET}save_tender?`+encodeQueryData(params);;
    let response = await http.post(url, params);
    return response;
}

async function getShareholderData(params:any) {
    const url = `${API_URL_SHAREHOLDER}Listofallshareholders?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function checkSplitLoan(params:any) {
    const url = `${API_URL_TARGET}checkSplitLoan?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function updateShareholderStatus(params:any) {
    const url = `${API_URL_TARGET}inactive_shareholder_loan?`+encodeQueryData(params);
    let response = await http.post(url, params);
    return response;
}

async function updateDisableMonthsConfig(params:any) {
    const url = `${API_URL_TARGET}update_disable_months?`+encodeQueryData(params);
    let response = await http.post(url, params);
    return response;
}

async function getDisableMonthsConfig(params:any) {
    const url = `${API_URL_TARGET}get_disable_months?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function getLogs(params:any) {
    const url = `${API_URL_TARGET}get_logs?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}  
async function getCustomerList(params:any = "") {
    const url = `${API_URL_TARGET}getCustomerList?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function getNewLoanCustomerList(params:any = "") {
    const url = `${API_URL_TARGET}getNewLoanCustomerList?${encodeQueryData(params)}`;
    let response = await http.get(url);
    return response;
}

async function saveCustomerLoan(params:any = "") {
    const url = `${API_URL_TARGET}saveCustomerLoan`;
    let response = await http.post(url, params);
    return response;
}

const HousingCompanyService = {
    getshareholder,
    getallshareholder,
    getmorethanoneapartment,
    getcompanyshareholder,
    getmorethantenpercent,
    getallhousingcompany,
    saveTender,
    getShareholderData,
    checkSplitLoan,
    updateShareholderStatus,
    updateDisableMonthsConfig,
    getDisableMonthsConfig,
    getLogs,
    getCustomerList,
    getNewLoanCustomerList,
    saveCustomerLoan,
};

export default HousingCompanyService;
